import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import useTranslate from '../../../i18n/useTranslate'
import MyDatePicker from '../../../control/datepicker/datepicker'
import Select from '../../../control/select/select'
import { HoldKeywordType } from '../../../services/um/useSearchHold'
import useProjectType from '../../../services/um/lookups/useProjectType'
import moment from 'moment'
import { FormApi } from 'final-form'

interface PanelProps {
    onSubmit: (values: HoldKeywordType) => void
    onReset: (form: FormApi<HoldKeywordType, Partial<HoldKeywordType>>) => void
    initialSearch: any
}
const Panel: FC<PanelProps> = ({ onSubmit, initialSearch, onReset }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const { projectT } = useProjectType()
    const [endDate, setEndDate] = useState<string | null>(moment(new Date()).format('YYYY-MM-DD'))

    const handleStartDateChange = (form: FormApi<HoldKeywordType>, value: string | null) => {
        if (value && endDate) {
            let isStartAfter = moment(value).isAfter(endDate)
            if (isStartAfter) {
                form.change('endDate', new Date(value))
            }
        }
    }

    const handleEndDateChange = (value: string | null) => {
        setEndDate(value)
    }

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialSearch}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="keyword"
                                    materialInputProps={{
                                        label: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.HOLD.PLACEHOLDER_KEYWORD')}`,
                                        size: 'small',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    name="projectType"
                                    option={[
                                        {
                                            value: null,
                                            label: translate.get('LABEL.NOT_SPECIFIC'),
                                        },
                                        ...projectT,
                                    ]}
                                    label={translate.get('LABEL.PROJECT_TYPE')}
                                    placeholder={translate.get('LABEL.PROJECT_TYPE')}
                                    size="small"
                                    defaultValue={initialSearch.projectType}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="startDate"
                                    label={translate.get('UM.HOLD.DATE_RECEIVE')}
                                    onChangeValue={(val: string) => handleStartDateChange(form, val)}
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="endDate"
                                    minDate={new Date(values.startDate)}
                                    label={translate.get('LABEL.END_DATE')}
                                    onChangeValue={handleEndDateChange}
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onReset(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

export default Panel

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    container: {
        padding: '1.7rem',
    },
}))
